const prod_config = {
  PUBLIC_PATH: "/surgery",
  APISERVER_URL: "//api.liangyihui.net/",
  NODESERVER_URL: "//web.liangyihui.net/",
  LOCAL_URl: "http://cdnmini.liangyihui.net/surgery/#/",
};
// export default prod_config;
module.exports = prod_config;
